import { DiffMatchPatch } from './diff-match-patch';
export var createDiffs = function createDiffs(a, b) {
  var postProcessors = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var diff = DiffMatchPatch.diff_linesToWords_(a, b);
  var diffs = DiffMatchPatch.diff_main(diff.chars1, diff.chars2, false);
  DiffMatchPatch.diff_charsToLines_(diffs, diff.lineArray);
  var normalized = diffs.map(function (diff) {
    return {
      type: diff[0],
      text: diff[1],
      length: diff[1].length
    };
  });
  return postProcessors.reduce(function (diffs, proc) {
    return proc(diffs);
  }, normalized);
};